import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientConnectorPingImplEncoder } from "../../encoder/ClientConnectorPingImplEncoder";

import * as CubiqTS from "../../index";
import { ClientConnectorPing } from "../ClientConnectorPing";

export class ClientConnectorPingImpl extends ConcreteEncodable implements ClientConnectorPing {
  public static enType: string = "com.bcdfx.messaging.server.ClientConnectorPingImpl";

  /*FID=1*/
  public clientSessionID: string;
  /*FID=2*/
  public timeStamp: CubiqTS.Long | null = null;
  /*FID=3*/
  public pingId: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientConnectorPingImplEncoder.Instance;
    this.setEncodableType(ClientConnectorPingImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ClientConnectorPingImpl[" +
      "clientSessionID=" +
      this.clientSessionID +
      "timeStamp=" +
      this.timeStamp +
      "pingId=" +
      this.pingId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
